import Content from './content';
import Wrappers from './wrappers';

const Application = {
  Content,
  Wrappers,
};

export default Application;
